"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthServiceStub = void 0;
const faker = __importStar(require("faker"));
const dummyUser = {
    displayName: faker.name.findName(),
    uid: faker.random.uuid(),
    email: faker.internet.email(),
};
class AuthServiceStub {
    // Future use is possible
    // eslint-disable-next-line
    constructor() { }
    loginWithUsernameAndPassword(username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            if (username && password) {
                return {
                    status: true,
                    message: "User account status",
                    payload: null,
                };
            }
            return null;
        });
    }
    loginWithGoogle() {
        return __awaiter(this, void 0, void 0, function* () {
            return faker.random.alphaNumeric(12);
        });
    }
    signUp(user, selectedPlanName) {
        return __awaiter(this, void 0, void 0, function* () {
            if (user && selectedPlanName) {
                return faker.random.alphaNumeric(12);
            }
            return null;
        });
    }
    signOut() {
        return null;
    }
    currentUser() {
        return __awaiter(this, void 0, void 0, function* () {
            return dummyUser;
        });
    }
    getIdToken() {
        return __awaiter(this, void 0, void 0, function* () {
            return faker.random.alphaNumeric(12);
        });
    }
    createNomineeAccount(userId, createNomineeAccountRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            if (userId && createNomineeAccountRequestBody) {
                return faker.random.boolean()
                    ? Promise.resolve({
                        status: true,
                        message: "Account created successfully",
                        payload: "some-token",
                    })
                    : // eslint-disable-next-line prefer-promise-reject-errors
                        Promise.reject({
                            status: false,
                            message: "Unable to create new account",
                            payload: null,
                        });
            }
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject({
                status: false,
                message: "Invalid request",
                payload: null,
            });
        });
    }
    createInvestorAccount(userId, createInvestorRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            if (userId && createInvestorRequestBody) {
                return faker.random.boolean()
                    ? Promise.resolve({
                        status: true,
                        message: "Account created successfully",
                        payload: "some-token",
                    })
                    : // eslint-disable-next-line prefer-promise-reject-errors
                        Promise.reject({
                            status: false,
                            message: "Unable to create new account",
                            payload: null,
                        });
            }
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject({
                status: false,
                message: "Invalid request",
                payload: null,
            });
        });
    }
    createAdminAccount(adminUserId, companyId, createNewAdminAccountRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            if (adminUserId && companyId && createNewAdminAccountRequestBody) {
                return faker.random.boolean()
                    ? Promise.resolve({
                        status: true,
                        message: "Account created successfully",
                        payload: "some-token",
                    })
                    : // eslint-disable-next-line prefer-promise-reject-errors
                        Promise.reject({
                            status: false,
                            message: "Unable to create new account",
                            payload: null,
                        });
            }
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject({
                status: false,
                message: "Invalid request",
                payload: null,
            });
        });
    }
    onAuthStateChanged(callback) {
        return __awaiter(this, void 0, void 0, function* () {
            callback(dummyUser);
        });
    }
}
exports.AuthServiceStub = AuthServiceStub;
//# sourceMappingURL=AuthServiceStub.js.map